module.exports = __webpack_public_path__ + "static/media/growth.015efb66.png";